// src/components/UserFormModal.js

import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, FormControl, InputLabel, Select, MenuItem, CircularProgress, Typography, Alert } from '@mui/material';

const UserFormModal = ({ isOpen, onClose, onSave, userToEdit }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('Usta');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  const isEditMode = Boolean(userToEdit);
  const availableRoles = ['Genel Müdür', 'Müdür', 'Koordinatör', 'Usta'];

  useEffect(() => {
    if (userToEdit) {
      setUsername(userToEdit.username || '');
      setEmail(userToEdit.email || '');
      setRole(userToEdit.role || 'Usta');
      setPassword('');
    } else {
      setUsername('');
      setEmail('');
      setPassword('');
      setRole('Usta');
    }
    setError('');
  }, [userToEdit, isOpen]);

  const handleSave = async () => {
    setError('');

    if (!isEditMode && (!username || !email || !password || !role)) {
      setError('Tüm alanların doldurulması zorunludur.');
      return;
    }

    if (isEditMode && (!username || !role)) {
      setError('Kullanıcı adı ve rol zorunludur.');
      return;
    }

    setIsSaving(true);
    try {
      const userData = { username, role };
      if (!isEditMode) {
        userData.email = email;
        userData.password = password;
      }
      await onSave(userData);
      handleClose();
    } catch (err) {
      console.error("Kullanıcı kaydetme hatası:", err);
      setError(err.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    setUsername('');
    setEmail('');
    setPassword('');
    setRole('Usta');
    setError('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEditMode ? 'Kullanıcıyı Düzenle' : 'Yeni Kullanıcı Ekle'}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate autoComplete="off" sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Kullanıcı Adı"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            required
            autoFocus
          />
          {!isEditMode && (
            <>
              <TextField
                label="E-posta Adresi"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                required
              />
              <TextField
                label="Şifre"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                required
                helperText="Şifre en az 6 karakter olmalıdır."
              />
            </>
          )}
          {isEditMode && (
            <Alert severity="info" sx={{ mb: 1 }}>
              E-posta: <strong>{userToEdit?.email}</strong> (değiştirilemez)
            </Alert>
          )}
          <FormControl fullWidth required>
            <InputLabel id="role-select-label">Rol</InputLabel>
            <Select
              labelId="role-select-label"
              value={role}
              label="Rol"
              onChange={(e) => setRole(e.target.value)}
            >
              {availableRoles.map(r => (
                <MenuItem key={r} value={r}>{r}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {error && <Typography color="error" sx={{ mt: 1 }}>{error}</Typography>}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={handleClose} disabled={isSaving}>İptal</Button>
        <Button onClick={handleSave} variant="contained" disabled={isSaving}>
          {isSaving ? <CircularProgress size={24} /> : (isEditMode ? 'Değişiklikleri Kaydet' : 'Kullanıcıyı Kaydet')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserFormModal;